module.exports = __webpack_public_path__ + "static/img/6.a1b96aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/6.png
// module id = z1Mm
// module chunks = 0